import { combineReducers } from 'redux';
import SystemSettingsReducer from "./SystemSettings";
import popup from './popup';
import DocumentReducer from './DocumentReducer';
import CommandsReducer from './CommandsReducer';
import locationDataReducer from './locationData';

const reducers = combineReducers({
  
  popup,
  DocumentReducer,
  SystemSettingsReducer,
  CommandsReducer,
  locationDataReducer
  
})


export default reducers;